<template>
  <div>
    <div class="toph mb16" >
      <span>待租库存</span>
      <div class="for-rent">
        <Select v-model="searchData.stockOrderStatus" placeholder="预订状态" @on-change="inputChange" style="width: 100px;">
          <Option value=''>请选择</Option>
          <Option  v-for="item in stockOrderStatusEnum" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
        <Select v-model="searchData.stockStatus" placeholder="房源状态" @on-change="inputChange" style="width: 100px;">
          <Option value=''>请选择</Option>
          <Option  v-for="item in stockStatusEnum" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
        <Select v-model="searchData.houseTypeFid" placeholder="请选择房型" @on-change="inputChange" style="width: 100px;">
          <Option value=''>请选择</Option>
          <Option  v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
        <Select
          style="width: 150px ;"
          v-model="searchData.stockFid"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          :defaultTem='true'
          placeholder="请输入房间号/床位号"
          @on-change="inputChange">
          <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
        <label @click.stop="inputChange" style="display: flex; margin-left: 5px">
          <Icon type="ios-search" size="24" color="#CFA868"/>
        </label>
      </div>
    </div>
    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'空置'+' '+kzNum" name="kz"></TabPane>
        <TabPane :label="'即将退租'+' '+jjtzNum" name="jjtz"></TabPane>
      </Tabs>

      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :defaultTem="isShow"
        :pageSize="5"
      >
      </table-list>

      <read-modal :n="readKey" :labelType ="type" :labelUnique="fid"></read-modal>
      <update-modal :n="updateKey" :labelType ="type" :labelUnique="fid" @refresh="findData"></update-modal>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import { getHouseType, getForRentNum, getOrderFid } from "api/house"
  import { fuzzyRoom } from 'api/functionalArea'
  import { getContractEndList} from 'api/contractList'
  import { getVacancyForRentList} from 'api/house'
  import {formatDateTime} from "@//utils/format"
  import ReadModal from "./components/ReadModal"
  import UpdateModal from "./components/UpdateModal"

  export default {
    name: "ForRent",
    components: {
      TableList,
      ReadModal,
      UpdateModal
    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.searchData.houseTypeFid = ''
        this.searchData.stockFid = ''
        this.page=1
        this.current=1
        this.getForRentNum()
        this.getHouseTypeList()
      },
      shortCut1(value) {
        this.clearValue()
        this.page=1
        this.current=1
        this.getpageList();
      }
    },
    computed:{
      othersColumns(){
        if(this.shortCut1=='kz'){
          return [{
            title: '空置天数',
            key: 'stockVacancyDay',
            align: 'center',
            width:180
          },{
            title:' ',
          },{
            title: '房间状态',
            key: 'stockStatusCn',
            align: 'center',
            width:180
          },{
            title:' ',
          }]
        } else if(this.shortCut1=='jjtz'){
          return [{
            title: '租约类型',
            key: 'rentTypeCn',
            align: 'center',
            width:180
          },{
            title:' ',
          },{
            title: '类型',
            key: 'typeName',
            width:150,
            align: 'center'
          },{
            title:' ',
          }]
        }
      },
      contractColumn(){
        if(this.shortCut1=='kz'){
          return [
            {
              title: '房间/床位号',
              key: 'stockNumber',
              width:120,
              align: 'center'
            },
            {
              title:' ',
            }
          ]
        } else if(this.shortCut1=='jjtz'){
          return [{
            title: '合同号',
            key: 'contractCode',
            align: 'center',
            width:180,
            render:(h,param)=>{
              return h('a',{
                on:{
                  click:()=>{
                    const code=param.row['contractCode']
                    this.$routerGo({name:'contractList',params:{cusPhoneNumber:code}})
                    // this.$router.push({ name: 'order',params: {cusPhoneNumber:code,targetTab:'1'}})
                  }
                }
              },param.row['contractCode'])
            }
          },{
            title:' ',
          }, {
            title: '房间/床位号',
            key: 'stockNumber',
            width:120,
            align: 'center'
          },
            {
              title:' ',
            },{
              title: '剩余天数',
              key: 'remainderDays',
              width:150,
              align: 'center'
            },{
              title:' ',
            },{
              title: '预计退租时间',
              key: 'conEndDate',
              align: 'center',
              width:180,
              render: (h,params) => {
                return h('div',formatDateTime(params.row.conEndDate, false).slice(0, 16))
              }
            },{
              title:' ',
            }]
        }
      },
      columns(){
        return [
          {
            type: "index",
            key: "index",
            width: 60,
            align: "center"
          },
          {
            title:' ',
          },
          ...this.contractColumn,
          {
            title:' ',
          },
          {
            title: '预订状态',
            key: 'stockOrderStatusCn',
            align: 'center',
            width: 90,
            render: (h, params) => {
              const status = params.row['stockOrderStatus'];
              const statusTextColor = status === 3 || status === 2 ? 'color: #CFA868; cursor: pointer' : '';
              const toOrderDetail = () => {
                getOrderFid({stockFid: params.row.fid}).then(res => {
                  if (res.code === 0) {
                    this.$router.push('/contractmanger/book/personbookinfo?fid=' + res.data);
                  } else {
                    this.$Message.warning('查询预订单号错误');
                  }
                }).catch(error => {});
              };
              return h('span', {
                attrs: {
                  style: statusTextColor
                },
                on: {
                  click: toOrderDetail
                }
              }, params.row['stockOrderStatusCn'])
            }
          },
          {
            title:' ',
          },
          {
            title: '房源状态',
            key: 'stockStatusCn',
            align: 'center',
            width: 90,
          },
          {
            title: '',
          },
          {
            title: '标准月租金',
            key: 'stockRentPrice',
            align: 'center',
            width: 100,
          },
          {
            title:' ',
          },
          {
            title: '房型',
            key: 'houseTypeName',
            align: 'center',
            width:180
          },
          {
            title:' ',
          },
          {
            title: '朝向',
            key: 'stockDirectionCn',
            align: 'center',
            width:80
          },
          {
            title:' ',
          },
          ...this.othersColumns,

          {
            title: '最新跟进内容',
            key: 'remark',
            width:150,
            align: 'center',
            render: (h, params) => {
              if (params.row['remark'] && params.row['remark'].length > 7) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['remark']),
                  h('span', {}, params.row['remark'].slice(0, 7) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['remark'])
              }
            }
          },
          {
            title:' ',
          },
          {
            title: '最新跟进时间',
            key: 'followTime',
            width:110,
            align: 'center',
            render: (h,params) => {
              return h('div',formatDateTime(params.row.followTime, true).slice(0, 16))
            }
          },
          {
            title:' ',
          },{
            title:'操作',
            key:'action',
            align:'center',
            fixed:'right',
            width:150,
            render: (h,params) =>{
              return h('div',[h('a',{
                style: {
                  marginRight: '5px',
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'houseInfo/getForRentFollowList'
                    }
                  }
                ],
                on:{
                  click: () => {
                    this.fid = params.row.fid
                    if(this.shortCut1 === 'kz'){
                      this.type = 0
                    }else if(this.shortCut1 === 'jjtz'){
                      this.type = 1
                    }
                    this.readKey++
                  }
                }
              },'查看'),
                h('a',{
                  style: {
                    marginRight: '5px',
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'houseInfo/saveForRentFollow'
                      }
                    }
                  ],
                  on:{
                    click: () => {
                      this.fid = params.row.fid
                      if(this.shortCut1 === 'kz'){
                        this.recordCut = 'kz'
                        this.type = 0
                      }else if(this.shortCut1 === 'jjtz'){
                        this.recordCut = 'jjtz'
                        this.type = 1
                      }
                      this.updateKey++
                    }
                  }
                },'跟进')
              ])
            }
          }
        ]
      }

    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        shortCut1: 'kz',
        recordCut:'',
        page: 1,
        limit: 5,
        searchData: {
          stockFid:'',
          houseTypeFid:'',
          stockOrderStatus: '',
          stockStatus: '',
        },
        kzNum: 0,
        jjtzNum: 0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        houseTypeList:[],
        stockOrderStatusEnum: [],
        stockStatusEnum: [],
        roomList:[],
        readKey:0,
        updateKey:0,
        fid:'',
        type:0,
        isShow:false
      }
    },
    methods: {
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
          ...this.searchData
        }
        if(this.shortCut1 === 'kz'){
          getVacancyForRentList(params).then(res => {
            if(!res.data){
              return
            }
            this.data = res.data.rows
            if(this.data.length<=0 ) {
              this.isShow = true;
            }
            this.total = res.data.total
          }).catch(error=>{})
        }else if(this.shortCut1 === 'jjtz'){
          getContractEndList(params).then(res => {
            if(!res.data){
              return
            }
            this.data = res.data.rows
            if(this.data.length<=0 ) {
              this.isShow = true;
            }
            this.total = res.data.total
          }).catch(error=>{})
        }
      },
      getForRentNum() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          ...this.searchData
        }
        getForRentNum(params).then(res => {
          if(!res.data){
            return
          }

          res.data.forEach((ele)=>{
            if(ele.forRentType == 0){
              this.kzNum = ele.number
            }else if (ele.forRentType == 1){
              this.jjtzNum = ele.number
            }
          })
          this.locationTab()
          this.getpageList()
        }).catch(error => {

        })
      },
      findData(){
        // if (this.data.length === 1) {
        //   this.current=1
        //   this.page=1
        // }
        this.getForRentNum()
      },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      inputChange(){
        this.current=1
        this.page=1
        this.data=[]
        if(this.shortCut1 === 'kz'){
          this.recordCut = 'kz'
        }else if(this.shortCut1 === 'jjtz'){
          this.recordCut = 'jjtz'
        }
        this.getForRentNum()
      },
      locationTab() {
        if(this.recordCut === 'kz'){
          this.shortCut1='kz'
          return
        }else if(this.recordCut === 'jjtz'){
          this.shortCut1='jjtz'
          return
        }

        if(this.kzNum){
          this.shortCut1='kz'
        }else if(this.jjtzNum){
          this.shortCut1='jjtz'
        }else {
          this.shortCut1='kz'
        }
      },
      getHouseTypeList() {
        if(!this.projectFid){
          this.houseTypeList = []
          return
        }
        getHouseType(this.projectFid).then(res => {
          this.houseTypeList = res.data.houseTypeList;
          this.stockOrderStatusEnum = res.data.stockOrderStatusEnum;
          this.stockStatusEnum = res.data.stockStatusEnum;
        })
      },
      remoteMethod(query){
        if (query !== '' && this.projectFid !=='') {
          this.loading = true;
          const params = {
            housetypeid:this.searchData.houseTypeFid,
            projectid:this.projectFid,
            housetypeid:this.searchData.houseTypeFid,
            roomnumber:query
          }
          fuzzyRoom(params).then( res => {
            this.loading = false;
            this.roomList = res.data;
          })
        } else {
          this.roomList = [];
          this.searchData.stockFid = ''
        }
      },
      initData(){
        this.getForRentNum()
        this.getHouseTypeList()
      },
    },
    created() {
      this.initData()
    }
  }
</script>

<style scoped>
  .topitem{
    width: 150px;
    text-align: center;
    line-height: 2.2;


  }
  .activeitem{
    color: #CFA868;
  }
  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }
  .for-rent{
    display: flex;
    align-items: center;
  }
  .for-rent > div {
    margin-right: 2px;
  }
</style>
